import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConsultationApiService {

    // region Variables

    private apiBasePath: string | undefined = environment.config.apiBasePath;
    private routerPath: string = 'design';
    private http: HttpClient = inject(HttpClient);

    // endregion

    // Constructor
    constructor() {
    }

    // Generic error handler
    private handleError(error: HttpErrorResponse): Observable<any> {

        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            if (error.status === 401) {
                return throwError(() => new Error(error.error.message || 'Unauthorized'));
            }
        }

        return throwError(() => 'Failed to fulfill request.');

    }

    // Submit Consultation
    submitConsultation(_options?: any): Observable<any> {

        if (!_options) return throwError(() => new Error('Form data is required.'));

        const url = `${this.apiBasePath}${this.routerPath}/submitConsultation`;
        return this.http.post(url, _options).pipe(catchError(this.handleError.bind(this)));

    }

}
